import { useEffect, useRef, useState } from 'react'

export const useMarqueeScroll = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isScrolling, setIsScrolling] = useState(false)
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleTouchStart = () => {
      setIsScrolling(true)
      if (container) {
        container.classList.add('marquee-paused')
      }
    }

    const handleTouchMove = () => {
      setIsScrolling(true)
      if (container) {
        container.classList.add('marquee-paused')
      }
    }

    const handleTouchEnd = () => {
      // Kısa bir süre sonra animasyonu tekrar başlat
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
      scrollTimeoutRef.current = setTimeout(() => {
        setIsScrolling(false)
        if (container) {
          container.classList.remove('marquee-paused')
        }
      }, 2000) // 2 saniye sonra animasyonu tekrar başlat
    }

    container.addEventListener('touchstart', handleTouchStart, { passive: true })
    container.addEventListener('touchmove', handleTouchMove, { passive: true })
    container.addEventListener('touchend', handleTouchEnd, { passive: true })

    return () => {
      container.removeEventListener('touchstart', handleTouchStart)
      container.removeEventListener('touchmove', handleTouchMove)
      container.removeEventListener('touchend', handleTouchEnd)
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [])

  return containerRef
}















